module.exports = __webpack_public_path__ + "img/1.611dc024.jpg";